/**
 * The settings for the Dialog actions when the Dialog is opened through `DialogService`.
 *
 * For an example on sample usage, refer to the
 * [`DialogService.open`]({% slug api_dialog_dialogservice %}#toc-open) method.
 */
var DialogAction = /** @class */ (function () {
    function DialogAction() {
    }
    return DialogAction;
}());
export { DialogAction };
/**
 * Indicates that the **Close** button is clicked.
 * Used when the results from the Dialogs that are opened through `DialogService` are filtered.
 *
 * For an example on sample usage, refer to the
 * [`DialogService.open`]({% slug api_dialog_dialogservice %}#toc-open) method.
 */
var DialogCloseResult = /** @class */ (function () {
    function DialogCloseResult() {
    }
    return DialogCloseResult;
}());
export { DialogCloseResult };
/**
 * The settings that can be used when opening a Dialog through `DialogService`.
 *
 * For an example on sample usage, refer to the
 * [`DialogService.open`]({% slug api_dialog_dialogservice %}#toc-open) method.
 */
var DialogSettings = /** @class */ (function () {
    function DialogSettings() {
    }
    return DialogSettings;
}());
export { DialogSettings };
/**
 * Holds references to the object instance and published events of the Dialog.
 * Controls the Dialogs that were opened through the `DialogService`.
 *
 * For an example on sample usage, refer to the
 * [`DialogService.open`]({% slug api_dialog_dialogservice %}#toc-open) method.
 */
var DialogRef = /** @class */ (function () {
    function DialogRef() {
    }
    return DialogRef;
}());
export { DialogRef };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dialog/dist/es/dialog/dialog-settings.js
// module id = ../../../../@progress/kendo-angular-dialog/dist/es/dialog/dialog-settings.js
// module chunks = vendor